import * as React from "react";
function SvgFacebookReactionWow(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} fill="#fddb74" />
      <path
        d="M24 24.88c-3.1 0-6.83 3.74-6.83 9.82S21 43.64 24 43.64s6.81-2.87 6.81-8.94-3.99-9.82-6.81-9.82zm14.38-7.71c-.4-2.66-2.22-4.59-4.06-4.32s-3 2.66-2.61 5.32 2.22 4.59 4.06 4.32 3-2.67 2.62-5.33zm-4.83-11a3.68 3.68 0 012.7 1 1 1 0 101.29-1.41 5.56 5.56 0 00-4.16-1.46 4.07 4.07 0 00-3 1.62A1 1 0 1032 7a2.18 2.18 0 011.56-.85zm-19.89 6.7c-1.84-.28-3.66 1.65-4.06 4.32s.77 5 2.61 5.32 3.66-1.65 4.06-4.32-.75-5.07-2.6-5.35zm3.88-7a4.07 4.07 0 00-2.95-1.62 5.56 5.56 0 00-4.16 1.46 1 1 0 101.29 1.41 3.67 3.67 0 012.7-1A2.18 2.18 0 0116 7a1 1 0 101.56-1.14z"
        fill="#282c39"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookReactionWow);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
